import { createI18n } from 'vue-i18n';
import uz from './uz';

export type MessageSchema = typeof uz;

/**
 * Hozircha faqat o'zbek (lotin). Kirill va rus tillari shu kalitlarni
 * takrorlab `messages` ga qo'shiladi; kalit yo'q bo'lsa uz'ga qaytadi.
 */
export const i18n = createI18n<[MessageSchema], 'uz'>({
  legacy: false,
  locale: 'uz',
  fallbackLocale: 'uz',
  messages: { uz },
});

/**
 * Komponentdan TASHQARIDAGI kod uchun (masalan `components/book/bookCard.ts`
 * — u prop'larni sof funksiya sifatida yasaydi). `useI18n()` faqat `setup()`
 * ichida ishlaydi, shuning uchun global instansiyaning `t` si.
 */
export const t = (key: string, named?: Record<string, unknown>): string =>
  named === undefined
    ? (i18n.global.t as (k: string) => string)(key)
    : (i18n.global.t as (k: string, n: Record<string, unknown>) => string)(key, named);
